import { render, staticRenderFns } from "./LoginWithTwitterButton.vue?vue&type=template&id=2d318aa2&scoped=true&"
import script from "./LoginWithTwitterButton.vue?vue&type=script&lang=js&"
export * from "./LoginWithTwitterButton.vue?vue&type=script&lang=js&"
import style0 from "./LoginWithTwitterButton.vue?vue&type=style&index=0&id=2d318aa2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d318aa2",
  null
  
)

export default component.exports